export function getFeatureCoordinates (featureId) {
  return this.getFeatureById(featureId).coordinates
}
